import {
	IGetGameInfo,
	IGetGamesShort,
	IGetGamesShortResponse,
	ICreateGame,
	IEditGame,
	IGetPaginatedGames,
	IGames,
	IGetGamePositionList,
	IGetGamePositionChains,
	IUpdateGamePositions,
	IGetRestaurantsByIDsCustomersForGames,
	IGetGamesByIDsRestaurantsForGames,
	IAssignGames,
	IGetGameCategoryInfo,
	IGetGameCategoriesShort,
	ICreateGameCategory,
	IUpdateGameCategory,
	IGetPaginatedGameCategories,
	IGameCategories,
	IGetGameDeveloperInfo,
	IGetGameDevelopersShort,
	ICreateGameDeveloper,
	IUpdateGameDeveloper,
	IGetPaginatedGameDevelopers,
	IGameDevelopers,
	IGetCustomersForAssignGame,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetGameInfo = (gameID: string): Promise<IGetGameInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Games/${gameID}` });
};

const serviceGetGamesShortInfo = (data: IGetGamesShort): Promise<IGetGamesShortResponse> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/games/short`, data });
};

const serviceCreateGame = (data: ICreateGame): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Games`, data });
};

const serviceEditGame = (data: IEditGame): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Games/${data.id}`, data });
};

const serviceGetPaginatedGames = (args: IGetPaginatedGames): Promise<AxiosResponse<IGames>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Games/filtered`, data: args });
};

const serviceDeleteGame = (gameID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/Games/${gameID}` });
};

const serviceGetGamePositionList = (restaurantID: string): Promise<IGetGamePositionList> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/restaurants/${restaurantID}/game-positions` });
};

const serviceGetGamePositionChains = (restaurantID: string): Promise<IGetGamePositionChains> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/restaurants/${restaurantID}/identical-game-set` });
};

const serviceUpdateGamePositions = (data: IUpdateGamePositions): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/game-positions`, data });
};

const serviceGetCustomersForAssignGame = (): Promise<IGetCustomersForAssignGame> => {
	return request({ typeOfRequest: 'getWithToken', url: '/api/GamesAssignment/customers' });
};

const serviceGetRestaurantsByIDsCustomersForGames = (
	customerIDs: string[],
): Promise<IGetRestaurantsByIDsCustomersForGames> => {
	const dataForRequest = {
		customerIds: customerIDs,
	};
	return request({ typeOfRequest: 'postWithToken', url: `/api/GamesAssignment/customers`, data: dataForRequest });
};

const serviceGetGamesByIDsRestaurantsForGames = (
	restaurantIDs: string[],
): Promise<IGetGamesByIDsRestaurantsForGames> => {
	const dataForRequest = {
		restaurantIds: restaurantIDs,
	};
	return request({ typeOfRequest: 'postWithToken', url: `/api/GamesAssignment/restaurants`, data: dataForRequest });
};

const serviceAssignGames = (data: IAssignGames[]): Promise<AxiosResponse<void>> => {
	const dataForAssign = {
		assignments: data,
	};
	return request({ typeOfRequest: 'putWithToken', url: '/api/GamesAssignment/assign', data: dataForAssign });
};

// GameCategories
const serviceGetGameCategoryInfo = (categoryID: string): Promise<IGetGameCategoryInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/GameCategories/${categoryID}` });
};

const serviceGetGameCategoriesShortInfo = (): Promise<IGetGameCategoriesShort> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/GameCategories/short` });
};

const serviceGetGameCategoriesShortInfoByRestaurantIDs = (
	restaurantIds: string[],
): Promise<IGetGameCategoriesShort> => {
	const dataForRequest = {
		restaurantIds,
	};
	return request({ typeOfRequest: 'postWithToken', url: '/api/GameCategories/short', data: dataForRequest });
};

const serviceCreateGameCategory = (data: ICreateGameCategory): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/GameCategories`, data });
};

const serviceUpdateGameCategory = (data: IUpdateGameCategory): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/GameCategories/${data.id}`, data });
};

const serviceGetPaginatedGameCategories = (
	args: IGetPaginatedGameCategories,
): Promise<AxiosResponse<IGameCategories>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/GameCategories/filtered`, data: args });
};

const serviceDeleteGameCategory = (categoryID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/GameCategories/${categoryID}`,
	});
};
// GameCategories

// GameDevelopers
const serviceGetGameDeveloperInfo = (developerID: string): Promise<IGetGameDeveloperInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/GameDevelopers/${developerID}` });
};

const serviceGetGameDevelopersShortInfo = (): Promise<IGetGameDevelopersShort> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/GameDevelopers/short` });
};

const serviceCreateGameDeveloper = (data: ICreateGameDeveloper): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/GameDevelopers`, data });
};

const serviceUpdateGameDeveloper = (data: IUpdateGameDeveloper): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/GameDevelopers/${data.id}`, data });
};

const serviceGetPaginatedGameDevelopers = (
	args: IGetPaginatedGameDevelopers,
): Promise<AxiosResponse<IGameDevelopers>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/GameDevelopers/filtered`, data: args });
};

const serviceDeleteGameDeveloper = (developerID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/GameDevelopers/${developerID}`,
	});
};
// GameDevelopers

export {
	serviceGetGameInfo,
	serviceGetGamesShortInfo,
	serviceCreateGame,
	serviceEditGame,
	serviceGetPaginatedGames,
	serviceDeleteGame,
	serviceGetGamePositionList,
	serviceGetGamePositionChains,
	serviceUpdateGamePositions,
	serviceGetCustomersForAssignGame,
	serviceGetRestaurantsByIDsCustomersForGames,
	serviceGetGamesByIDsRestaurantsForGames,
	serviceAssignGames,
	serviceGetGameCategoryInfo,
	serviceGetGameCategoriesShortInfo,
	serviceGetGameCategoriesShortInfoByRestaurantIDs,
	serviceCreateGameCategory,
	serviceUpdateGameCategory,
	serviceGetPaginatedGameCategories,
	serviceDeleteGameCategory,
	serviceGetGameDeveloperInfo,
	serviceGetGameDevelopersShortInfo,
	serviceCreateGameDeveloper,
	serviceUpdateGameDeveloper,
	serviceGetPaginatedGameDevelopers,
	serviceDeleteGameDeveloper,
};
